export const environment = {
  production: false,

  // appUrl: 'https://walaxtest.expertapps.com.sa',
  apiUrl: 'https://walaxtestapi.expertapps.com.sa/api',
  // signalR: 'https://diwandevslr.expertapps.com.sa/hubs',

  
  employee_link: "https://walaxemptest.expertapps.com.sa",
  mapsApiKey:"",
  googleSiteKey: '6Lfm3xohAAAAALgLSfUIY8YHdzC16AjLY6wl7U9a',
  googleApiKey: '6Lfm3xohAAAAADEauzDDPzU0YVrIxWTBbi1k3AkE',
};
